import * as React from 'react';

import { Input } from '@/components/TailwindComponents';
import { cn } from '@/components/TailwindComponents/lib/utils';

interface MaterialInputProps extends React.ComponentProps<'input'> {
  label?: string;
  error?: boolean;
  helperText?: string;
}

const MaterialInput = React.forwardRef<HTMLInputElement, MaterialInputProps>(
  ({ className, label, error, helperText, ...props }, ref) => {
    return (
      <div className="relative mb-4 w-full">
        {label && (
          <label
            className={cn(
              'block mb-2 text-sm font-medium',
              error ? 'text-red-500' : 'text-gray-700',
            )}
          >
            {label}
          </label>
        )}
        <Input
          className={cn(
            'border border-gray-300',
            'focus-visible:ring-0 focus-visible:border-gray-300',
            error ? '!border-red-500' : '',
            props.disabled ? 'bg-gray-200 border-none' : '',
            className,
          )}
          ref={ref}
          {...props}
        />
        {helperText && (
          <div
            className={cn(
              'text-xs mt-1 ml-1',
              error ? 'text-red-500' : 'text-gray-500',
            )}
          >
            {helperText}
          </div>
        )}
      </div>
    );
  },
);

MaterialInput.displayName = 'MaterialInput';

export { MaterialInput };
